<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
export default
{
    mixins: [ adminTable ],

    computed:
    {
        subscriberUrl()
        {
            return process.env.API_URL + this.url
        },
    },

    methods:
    {
        fetch()
        {
            this.data = []
            this.updateData()
            this.$snotify.async(this.$t('GENERAL.LOADING'), '', () => new Promise(async (resolve, reject) => {
                    axios.post(process.env.API_URL + this.url, { filters: this.filters }).then(res => {
                        this.data = res.data
                        this.updateData()
                        resolve({
                            title: '' ,
                            body: this.$t('GENERAL.DONE'),
                            config: {
                                timeout: 1000,
                                pauseOnHover: false,
                                showProgressBar: true,
                            },
                        })
                    }).catch(e => {
                        reject({
                            title:  '',
                            body: this.$t('GENERAL.ERROR'),
                            config: {
                                timeout: 1000,
                                pauseOnHover: false,
                                showProgressBar: true,
                            },
                        })
                     })
                })
                ,{ timeout: 1000, pauseOnHover: false, showProgressBar: true }
            )
        },
    },

    mounted()
    {
        this.$store.dispatch('artistCheck')
        this.$store.dispatch('artistCategoryCheck')
        axios.get(process.env.API_URL + '/v1/admin/wishlists').then(({data}) => {
            this.wishlists = data
        })
    },

    data()
    {
        return {
            data: [],
            filters: { relation: 'or', rules: [], },
            wishlists: [],
            url: '/v1/admin/wishlistsignups/filter',
            tableName: 'tableSubscribers',
            emptyModel: { name: null, attachments: [], categories: [], },
            columns: [ 'id', 'name', 'email', 'status', 'created_at', 'purchased_at', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    name: this.$t('WISHLIST.NAME'),
                    active: this.$t('WISHLIST.ACTIVE'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                    purchased_at: this.$t('WISHLIST.PURCHASED_AT'),
                },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name',, 'email', 'created_at', 'purchased_at'],
            },
        }
    },

}
</script>

<template>
    <div class="container-fluid">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.SUBSCRIBERS') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>

            <div class="jumbotron">

                <mv-subscriber-filter v-model="filters"></mv-subscriber-filter>

                <div class="row">
                    <div class="col-xs-6">
                        <button class="btn btn-primary" @click="fetch">{{ $t('GENERAL.FILTER') }}</button>
                    </div>
                    <div class="col-xs-6 text-right">
                        <strong>{{ $t('WISHLIST.SUM', { sum: data.length }) }}</strong>
                    </div>
                </div>

            </div>
            <div class="panel-body">
                <v-client-table :url="subscriberUrl" :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                    </div>
                    <div slot="status" slot-scope="props">
                        <span class="label" 
                            :class="{ 'label-success': props.row.categories_done == 1, 'label-warning': props.row.categories_done == 0 }">
                            {{ $t('WISHLIST.CATEGORY')}}
                        </span>

                        <span class="label" 
                            :class="{ 'label-success': props.row.choices_done == 1, 'label-warning': props.row.choices_done == 0 }">
                            {{ $t('ARTIST.ARTIST')}}
                        </span>

                        <span class="label" 
                            :class="{ 'label-success': props.row.purchase_done == 1, 'label-warning': props.row.purchase_done == 0 }">
                            {{ $t('WISHLIST.PURCHASE')}}
                        </span>

                        <span class="label" 
                            v-if="props.row.purchase_done == 1"
                            :class="{ 'label-success': props.row.scancode, 'label-warning': !props.row.scancode }">
                            {{ $t('WISHLIST.SCANCODE')}}
                        </span>

                        <span class="label label-primary" 
                            v-if="props.row.referrer"
                            >
                            {{ $t('WISHLIST.REFERRER')}}
                        </span>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>




// WEBPACK FOOTER //
// src/pages/Subscribers.vue